import WDHRichText from "../../../../wdh-feature/wdh-rich-text/src/js/wdh-rich-text";
import WDHInlineImage from "../../../../wdh-feature/wdh-rich-text/src/js/variations/inline-image";
var richText = new WDHRichText();
richText.registerVariation(new WDHInlineImage());
richText.run();